<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :swimmingActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "plumbing",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "swimmingpool/IMG-20180209-WA0014.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20180209-WA0010.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20180209-WA0009.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20170906-WA0004.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20170827-WA0030.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20170827-WA0009.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20170827-WA0035.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "swimmingpool/IMG-20171007-WA0090.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Swimming pool",
    serviceDescription:
      "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Consectetur adipiscing elit. Integer adipiscing erat eget risus sollicitudin pellentesque et non erat tincidunt nunc posuere."
  })
};
</script>
